query PurchaseOrderFiltersData {
  
  availableSuppliers(orderBy: _FULL_NAME_ASC) {
    nodes {
      id
      _fullName
    }
  }
  companyPurchaseOrderTypes {
    nodes {
      id
      purchaseOrderTypeId
      purchaseOrderType
    }
  }
  companyDepartments(
    orderBy: [NAME_ASC, PRIMARY_KEY_ASC]
    filter: { _isSystemInternal: { notEqualTo: true } }
  ) {
    nodes {
      id
      name
      userDepartment {
        _isUserAssigned
      }
    }
  }
  companyBusinessUnits {
    nodes {
      id
      name
    }
  }
  companyCurrencies {
    nodes {
      id
      name
    }
  }
  purchaseOrderStatusTypes {
    nodes {
      id
      statusType
    }
  }
  purchaseOrderUsers(orderBy: [USER_NAME_ASC]) {
    nodes {
      userId
      userName
    }
  }
  purchaseOrderAccountingHistories(orderBy: REQUEST_DATE_DESC) {
    nodes {
      id
      exportInfo
    }
  }
}
